import { OpenNewTabTargetType } from "@voltmoney/types";
import { Platform } from "react-native";
import { ROUTE } from "../../routes";
import { api, StoreKey } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import { AppLink, PLATFORM_CODE, QUERY_PARAMS } from "../../configs/constants";
import sharedPropsService from "../../SharedPropsService";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { getParameters, getParametersFromURL } from "../../configs/utils";
export const onChangeDimension = async (action, _datastore, { hidePopup }) => {
    console.warn("**** onChangeDimension Action Triggered ****", action);
    const widthX = action.payload.width;
    const heightX = action.payload.height;
    const dimensionData = {
        height: heightX,
        width: widthX
    };
    if (Platform.OS === 'web') {
        // const dimensionEvent = new EventEmitter();
        // dimensionEvent.emit('getDimensionMarketing',  {id: 'getDimensionMarketing', data: dimensionData});
        //send message to parent iframe about dimension changes
        window.parent.postMessage({ id: 'getDimensionLeads', data: dimensionData }, '*');
    }
};
export const goToInit = async (action, _datastore, { navigateWithClear, asyncStorage }) => {
    console.warn("**** goToInit Action Triggered ****", action);
    if (Platform.OS === 'web') {
        window.parent.postMessage({ id: 'scrollToTop', data: true }, '*');
    }
    await sharedPropsService.setCustomerLeadAssetData({});
    await asyncStorage.set(StoreKey.LEAD_TOKEN, null);
    await navigateWithClear(ROUTE.CHECK_LIMIT_MFC_INIT);
};
export const goToViewDetails = async (action, _datastore, { navigateWithClear, instrumentTrack, addUseProperty, asyncStorage }) => {
    console.warn("**** goToViewDetails Action Triggered ****", action);
    const type = action?.payload?.type;
    const isFromEligible = action?.payload?.isFromEligible;
    const MfCentralInitResponse = await sharedPropsService.getMfCentralInitResponse();
    const leadId = MfCentralInitResponse?.leadId;
    const context = await asyncStorage.get(StoreKey.CONTEXT);
    if (context !== 'PARTNER') {
        if (isFromEligible) {
            instrumentTrack('MFC_VIEW_DETAILS_BUTTON_CLICKED', { type: 'eligible' });
            addUseProperty('lead_id', leadId);
        }
        else {
            instrumentTrack('MFC_VIEW_DETAILS_BUTTON_CLICKED', { type: 'non-eligible' });
            addUseProperty('lead_id', leadId);
        }
    }
    AsyncStorage.setItem("isEligible", isFromEligible).then(() => {
        navigateWithClear(ROUTE.CHECK_LIMIT_VIEW_DETAIL, { isFromEligible: isFromEligible });
    });
};
export const goToInfo = async (action, _datastore, { navigate, navigateWithClear }) => {
    console.warn("**** goToInfo Action Triggered ****", action);
    const title = action?.payload?.title;
    const type = action?.payload?.type;
    await navigate(ROUTE.CHECK_LIMIT_INFO, { title, type });
};
export const applyNow = async (action, _datastore, { setDatastore, network, asyncStorage, openNewTab, instrumentTrack, addUseProperty }) => {
    console.warn("**** applyNow Action Triggered ****", action);
    const context = await asyncStorage.get(StoreKey.CONTEXT);
    const partnerAccountId = action?.payload?.partnerAccountId;
    const widgetId = action.payload.widgetId;
    const MfCentralInitResponse = await sharedPropsService.getMfCentralInitResponse();
    const leadId = MfCentralInitResponse?.leadId;
    if (context !== 'PARTNER') {
        instrumentTrack('MFC_APPLY_NOW_BUTTON_CLICKED');
        addUseProperty('lead_id', leadId);
    }
    await setDatastore(action.routeId, widgetId, {
        loading: true
    });
    // await navigate(ROUTE.CHECK_LIMIT_INFO);
    if (Platform.OS === 'web') {
        const url = window.location.href;
        const params = getParameters(url);
        const platform = params[QUERY_PARAMS.PLATFORM];
        if (platform === PLATFORM_CODE.PHONEPE) {
            if (Platform.OS === 'web') {
                window.parent.postMessage({ id: 'setIsBorrowerConverted', data: true }, '*');
            }
        }
    }
    if (partnerAccountId && partnerAccountId !== '') {
        const userData = JSON.parse(await asyncStorage.get(StoreKey.U_DATA));
        const eventData = {
            ROUTE: ROUTE.PARTNER_LEAD,
            user_data: {
                phoneNumber: userData?.phoneNumber,
                pan: userData?.pan,
            }
        };
        //fire event
        if (Platform.OS === 'web') {
            console.log("event call here: ", eventData);
            window.parent.postMessage({ id: 'getUserData', data: eventData }, '*');
        }
    }
    else {
        const headers = await getAppHeader();
        headers['Authorization'] = `Bearer ${await asyncStorage.get(StoreKey.LEAD_TOKEN)}`;
        const convertLeadToCustomerResponse = await network.post(`${api.convertLeadToCustomerV2}`, {}, {
            headers: headers
        }, async () => { return; }, {
            isPartnerPlatform: true
        });
        if (convertLeadToCustomerResponse?.status === 200) {
            const params = getParametersFromURL();
            delete params['isIframe'];
            delete params['isCheckLimitMFC'];
            // const amplitudeDeviceId = params[QUERY_PARAMS.AMPLITUDE_DEVICE_ID];
            // const platform = params[QUERY_PARAMS.PLATFORM];
            // const utm_source = params[QUERY_PARAMS.UTM_SOURCE];
            const shortToken = convertLeadToCustomerResponse?.data?.jwt;
            // let link = `${AppLink}?plj=true&t=${shortToken}${amplitudeDeviceId && `&amplitudeDeviceId=${amplitudeDeviceId}`}${platform && `&platform=${platform}`}${utm_source ? `&utm_source=${utm_source}` : ''}`;
            let link = `${AppLink}?plj=true&t=${shortToken}`;
            params &&
                Object.keys(params).map((key) => {
                    link = link + `&${key}=${params[key]}`;
                });
            await openNewTab(link, OpenNewTabTargetType.parent);
        }
    }
    await setDatastore(action.routeId, widgetId, {
        loading: false
    });
};
export const goToRegisterLeads = async (action, _datastore, { navigate, navigateWithClear }) => {
    console.warn("**** goToRegisterLeads Action Triggered ****", action);
    let url = '';
    let phoneNumber = '';
    let panNumber = '';
    if (Platform.OS === 'web') {
        url = window.location.href;
        const params = getParameters(url);
        phoneNumber = params?.phonenumber;
        panNumber = params?.pan;
    }
    const eventData = {
        ROUTE: ROUTE.PARTNER_LEAD,
        user_data: {
            phoneNumber: phoneNumber,
            panNumber: panNumber
        }
    };
    if (Platform.OS === 'web') {
        window.parent.postMessage({ id: 'openRegisterLead', data: eventData }, '*');
    }
};
